import { ROUTES } from "~/const";
import { trans } from "~/utils/trans";

export interface ILinkItem {
	route: string;
	title: string;
	type: "admin" | "logged" | "unlogged" | "statistics" | "profile";
	onClick?: () => void;
}

export function getAdminLinks(): Array<ILinkItem> {
	/* eslint-disable-next-line */
	const REMOVED = [{
		route: ROUTES.unitsList,
		title: trans("adminPage.unitsList"),
		type: "admin",
	}, {
		route: ROUTES.mealsList,
		title: trans("adminPage.mealsList"),
		type: "admin",
	}];

	return [{
		route: ROUTES.recipes,
		title: trans("adminPage.recipes"),
		type: "admin",
	}, {
		route: ROUTES.ingredients,
		title: trans("adminPage.ingredients"),
		type: "admin",
	}, {
		route: ROUTES.tags,
		title: trans("adminPage.tags"),
		type: "admin",
	}, {
		route: ROUTES.users,
		title: trans("adminPage.users"),
		type: "admin",
	}, {
		route: ROUTES.mailTemplates,
		title: trans("adminPage.mailTemplates"),
		type: "admin",
	}, {
		route: ROUTES.menus,
		title: trans("adminPage.menus"),
		type: "admin",
	}];
}

// skupina "Informace" v hamburger menu, odkazy na web doitforyourself.cz
export function getInfoLinks(): Array<ILinkItem> {
	return [{
		route: ROUTES.howitworks,
		title: trans("menu.howitworks"),
		type: "unlogged",
	}, {
		route: ROUTES.conditions,
		title: trans("menu.conditions"),
		type: "unlogged",
	}, {
		route: ROUTES.home,
		title: trans("menu.web"),
		type: "unlogged",
	}];
}

// odkazy v paticce
export function getFooterLinks(): Array<ILinkItem> {
	return [{
		route: ROUTES.gdpr,
		title: trans("menu.gdpr"),
		type: "unlogged",
	}, {
		route: ROUTES.cookies,
		title: trans("menu.cookies"),
		type: "unlogged",
	}];
}

export function getHamburgerLinks(isLogged: boolean, isAdmin: boolean) {
	return [
		...isLogged
			? [{
				route: ROUTES.schedule,
				title: trans("menu.schedule"),
				type: "logged",
			},
			{
				route: ROUTES.weight,
				title: trans("menu.statistics"),
				type: "statistics",
			},
			{
				route: ROUTES.profile,
				title: trans("menu.profile"),
				type: "profile",
			}]
			: [{
				route: ROUTES.login,
				title: trans("menu.login"),
				type: "unlogged",
			}, {
				route: ROUTES.register,
				title: trans("menu.register"),
				type: "unlogged",
			}, {
				route: ROUTES.verify,
				title: trans("menu.verify"),
				type: "unlogged",
			}],
		...isAdmin
			? [{
				route: ROUTES.recipes,
				title: trans("menu.admin"),
				type: "admin",
			}]
			: [],
	] as Array<ILinkItem>;
}

export function getProfileLinks(): Array<ILinkItem> {
	return [{
		route: ROUTES.profile,
		title: trans("profilePage.title"),
		type: "profile",
	}, {
		route: ROUTES.preferences,
		title: trans("preferencesPage.title"),
		type: "profile",
	}, {
		route: ROUTES.favoriteRecipes,
		title: trans("favoriteRecipesPage.title"),
		type: "profile",
	}];
}

export function getStatisticsLinks(): Array<ILinkItem> {
	/*return [{
		route: ROUTES.weight,
		title: "Hmotnost",
		type: "statistics",
	}, {
		route: ROUTES.statsEnergy,
		title: "Energie",
		type: "statistics",
	}, {
		route: ROUTES.statsChest,
		title: "Obvod hrudi",
		type: "statistics",
	}, {
		route: ROUTES.statsWaist,
		title: "Obvod pasu",
		type: "statistics",
	}, {
		route: ROUTES.statsSide,
		title: "Obvod boků",
		type: "statistics",
	}, {
		route: ROUTES.statsInput,
		title: "Zadávání statistik",
		type: "statistics",
	}];*/

	return [{
		route: ROUTES.weight,
		title: trans("stats.weight"),
		type: "statistics",
	}, {
		route: ROUTES.statsWaist,
		title: trans("stats.waist"),
		type: "statistics",
	}, {
		route: ROUTES.statsChest,
		title: trans("stats.chest"),
		type: "statistics",
	}, {
		route: ROUTES.statsSide,
		title: trans("stats.side"),
		type: "statistics",
	}];
}
